import { render, staticRenderFns } from "./item_stats.vue?vue&type=template&id=16d54a24&"
import script from "./item_stats.vue?vue&type=script&lang=js&"
export * from "./item_stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "item_stats.vue"
export default component.exports